<template>
  <b-sidebar ref="noteSidebar" bg-variant="white" id="note-sidebar" no-header right shadow @hidden="clearNote" width="440px">
    <div class="p-4">
      <i class="fas fa-close position-absolute" v-b-toggle.note-sidebar></i>
      <div class="mt-5 py-2">
        <h3 class="mb-5">{{ title }}</h3>
        <b-form @submit.prevent="submit" v-if="!showTaskForm">
          <b-row class="mb-2">
            <b-col md="3">
              <label class="form-control-label pt-2" for="assigned_to_id">Title:</label>
            </b-col>
            <b-col md="9">
              <b-form-group>
                <b-input-group>
                  <b-form-input v-model="note.title" placeholder="Title" required></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col md="3">
              <label class="form-control-label pt-2" for="assigned_to_id">About:</label>
            </b-col>
            <b-col md="9">
              <el-select v-model="note.about_id" class="w-100" :disabled="$route.params.user">
                <el-option :value="null" label="Private Note - Not Assigned to Client"></el-option>
                <el-option v-for="user in users" :key="user.id" :value="user.id" :label="user.label"></el-option>
              </el-select>
            </b-col>
          </b-row>
          <b-row class="mb-3" v-if="note.about_id">
            <b-col md="9">
              <label class="form-control-label" for="note.visible">Visible to About User:</label>
            </b-col>
            <b-col md="3" class="text-right">
              <base-switch class="mr-1" v-model="note.visible"></base-switch>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label class="form-control-label" for="note.note">Notes:</label>
              <html-editor v-model="note.note" placeholder="Add Notes"></html-editor>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button type="submit" variant="success">Save</b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-form @submit.prevent="storeTask" v-if="showTaskForm">
          <b-form-group>
            <b-row>
              <b-col md="4">
                <label class="form-control-label pt-2" for="due_date">Due Date:</label>
              </b-col>
              <b-col md="8">
                <b-form-datepicker v-model="task.due_date" placeholder="Choose a date" local="en"></b-form-datepicker>
              </b-col>
            </b-row>
          </b-form-group>

          <div v-if="task.id" class="mb-3">
            <div class="d-flex justify-content-between align-items-center" v-if="task.completed">
              <label class="form-control-label" for="due_date">Completed At:</label>
              <label class="form-control-label">{{ task.completed_at }}</label>
            </div>
          </div>

          <b-form-group>
            <b-row>
              <b-col md="3">
                <label class="form-control-label" for="myTask">My Task:</label>
              </b-col>
              <b-col md="9" class="text-right">
                <base-switch class="mr-1" v-model="myTask"></base-switch>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group v-if="!myTask">
            <b-row>
              <b-col md="3">
                <label class="form-control-label pt-2" for="assigned_to_id">Assignee:</label>
              </b-col>
              <b-col md="9">
                <el-select v-model="task.assigned_to_id" placeholder="Select an Assignee">
                  <el-option :value="null" label="Select an Assignee"></el-option>
                  <el-option v-for="user in users" :key="user.id" :value="user.id" :label="user.label"></el-option>
                </el-select>
              </b-col>
            </b-row>
          </b-form-group>

          <base-input label="Task:"
                      label-for="task"
                      name="Task"
                      rules="required"
                      v-model="task.task">
          </base-input>

          <b-button block type="submit" variant="primary">Save</b-button>
          <b-button block variant="success" @click="complete" class="mb-2" v-if="task.id && !task.completed">Complete <i class="fas fa-check"></i></b-button>
          <b-button block variant="danger" @click="incomplete" class="mb-2" v-if="task.completed">Reactivate <i class="fas fa-check"></i></b-button>
        </b-form>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {Select, Option} from 'element-ui';
import errorsMixin from '@/mixins/errors-mixin';
import HtmlEditor from '@/components/Inputs/HtmlEditor';

export default {
  mixins: [errorsMixin],
  components: {
    HtmlEditor,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    noteId: null
  },
  data() {
    return {
      note: {
        id: null,
        title: '',
        note: '',
        about_id: null,
        visible: false,
      },
      users: [],
      task: {
        task: '',
        due_date: new Date(),
        completed_at: null,
        completed: false,
        assigned_to_id: null
      },
      showTaskForm: false
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    }),
    title() {
      if (this.showTaskForm) {
        return 'New Task';
      } else {
        return this.note.id ? 'Edit Note' : 'New Note';
      }
    }
  },
  methods: {
    async getNote() {
      await axios.get(this.userRoute + "/notes/note/" + this.noteId)
      .then(response => {
        this.note = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getUsers() {
      await axios.get(this.userRoute + "/mentionable-users")
      .then(response => {
        this.users = response.data;

        if (this.$route.params.user) {
          this.assignUser();
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
    submit() {
      if (this.note.id) {
        this.update();
      } else {
        this.create();
      }
    },
    async create() {
      await axios.post(this.userRoute + "/notes", this.note)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$emit('getNotes');
          this.createTask();
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async update() {
      await axios.patch(this.userRoute + "/notes/note/" + this.noteId)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$emit('getNotes');
          this.$refs.noteSidebar.hide();
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    clearNote() {
      this.note = {
        id: null,
        title: '',
        note: '',
        about_id: null,
        visible: false,
      };

      this.task = {
        task: '',
        due_date: new Date(),
        completed_at: null,
        completed: false,
        assigned_to_id: null
      };

      if (this.$route.params.user) {
        this.assignUser();
      }

      this.$emit('clearNote');
    },
    assignUser() {
      let observed = this.$store.getters['observed/observed'];

      this.note.about_id = this.users.filter(user => {
        return user.id == observed.id;
      })[0].id;

      this.task.assigned_to_id = this.note.about_id;
    },
    async storeTask() {
      await axios.post(this.userRoute + "/tasks", this.task)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.showTaskForm = false;
          this.$refs.noteSidebar.hide();
        });
      })
      .catch(error => {

      });
    },
    createTask() {
      swal.fire({
        title: `Success`,
        text: 'Would you like to create a task?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        buttonsStyling: false,
        icon: 'info'
      }).then(result => {
        if (result.isConfirmed) {
          this.showTaskForm = true;
        } else {
          this.$refs.noteSidebar.hide();
        }
      });
    },
  },
  created() {
    this.getUsers();
  },
  watch: {
    noteId(to, from) {
      if (to !== null) {
        this.getNote();
      }
    }
  }
};
</script>